import { render } from "./PurchaseRecord.vue?vue&type=template&id=48d1e2f8&scoped=true&ts=true"
import script from "./PurchaseRecord.vue?vue&type=script&lang=ts"
export * from "./PurchaseRecord.vue?vue&type=script&lang=ts"

import "./PurchaseRecord.vue?vue&type=style&index=0&id=48d1e2f8&lang=scss&scoped=true"

import exportComponent from "D:\\work\\CP_new_work\\saas-h5-project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48d1e2f8"]])

export default __exports__